const apiUrls = require("../../constants/apiUrls");
const houseEquipmentDetails = {
  key: "houseEquipmentDetails",
  apiUrl: apiUrls.HOUSE_EQUIPMENT_DETAILS_URL,
  method: "GET",
  getApiUrl: (request) => {
    return `${apiUrls.HOUSE_EQUIPMENT_DETAILS_URL}?houseNumber=${request.addressId}`;
  },
  dependencies: [
    {
      key: "schedulingSystemDetails",
      requestProps: [
        {
          path: ["details", "addressInfo", "addressId"],
          propName: "addressId",
        },
      ],
    },
  ],
};

export default houseEquipmentDetails;



// WEBPACK FOOTER //
// ./src/store/order-details-config/houseEquipmentDetails.js